import { Box, Button } from "@mui/material";
import { useEffect, useRef, useState } from "react";

import useModalDispatch from "../../hooks/useModalDispatch";
import CompensationQuoteModal from "../../modals/CompensationQuoteModal";
import Body from "../theme/Body";

const CompensationQuote = ({
  clamp,
  quote,
  userName,
}: {
  clamp?: boolean;
  quote?: string;
  userName: string;
}) => {
  const ref = useRef<HTMLDivElement>(null);
  const [clamped, setIsClamped] = useState(false);
  const dispatchQuoteModal = useModalDispatch(CompensationQuoteModal);

  useEffect(() => {
    if (ref.current) {
      const isTextClamped = (elm: Element) =>
        elm.scrollHeight > elm.clientHeight;

      new ResizeObserver((e) => {
        setIsClamped(isTextClamped(e[0].target));
      }).observe(ref.current);
    }
  }, [ref.current]);

  if (!quote) {
    return null;
  }

  return (
    <Box className="compensation-quote-wrapper">
      <Body
        className="compensation-quote"
        component="blockquote"
        sx={{
          lineHeight: "1.8em",
          marginX: 0,
          paddingLeft: "0.5em",
          borderLeft: "3px solid lightgray",
        }}
      >
        <Box
          sx={{
            position: "absolute",
            "&:before": {
              color: "#ccc",
              content: '"“"',
              fontSize: "4em",
              lineHeight: "0.1em",
              marginRight: "0.15em",
              verticalAlign: "-0.45em",
              fontFamily: "arial",
            },
          }}
        />
        <Box
          ref={ref}
          sx={{
            textIndent: "1.5em",
            overflow: "hidden",
            whiteSpace: "preserve-breaks",
            ...(clamp
              ? {
                  display: "-webkit-box",
                  "-webkit-line-clamp": "3",
                  lineClamp: "3",
                  "-webkit-box-orient": "vertical",
                }
              : {
                  display: "inline-block",
                }),
          }}
        >
          {quote}
        </Box>
        <Box alignItems="center" display="flex" justifyContent="space-between">
          {clamped ? (
            <Button
              sx={{ fontSize: "13px" }}
              variant="text"
              onClick={() => dispatchQuoteModal({ quote, userName })}
            >
              Lees meer
            </Button>
          ) : (
            <div />
          )}
          <Box
            className="compensation-quote-name"
            sx={{ fontSize: "14px", textAlign: "right" }}
          >
            - {userName}
          </Box>
        </Box>
      </Body>
    </Box>
  );
};

export default CompensationQuote;
